import { hasMarcusPayload, hasNativeFiles, parseDropPayload, type DroppedItem } from '~~/shared/documentDrop'

/**
 * The chat panel's drop contract, on the shared `shared/documentDrop.ts` helpers (MAR-957).
 *
 * The panel used to read the legacy single-item MIME by hand, which the drag source fills with only
 * the row under the pointer — so dropping a multi-selection attached one document. `ChatInput.vue` and
 * `DocumentPicker.vue` already parse the multi-item payload first; this keeps the panel on the same one.
 */

type DropData = Pick<DataTransfer, 'types' | 'getData'> | null | undefined

/** True when a drag over the chat panel carries something the panel accepts: Marcus items or OS files. */
export function acceptsChatDrop(dt: DropData): boolean {
  if (!dt) return false
  return hasMarcusPayload(dt.types) || hasNativeFiles(dt.types)
}

/** Every document a Marcus drag dropped on the chat panel carries. Folders are not expanded into chat context. */
export function documentsFromChatDrop(dt: DropData): DroppedItem[] {
  return parseDropPayload(dt as DataTransfer | null | undefined).filter(item => item.type === 'document')
}
